import { Alert } from 'avo-ui'
import { VotingList } from 'components/award/voting/voting-list/VotingList'
import { INITIAL_DATA_FILTER } from 'configs/award/configTableVoting'
import { ACTION_TYPE } from 'constants/constant'
import { useEffect } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { API_AWARD } from 'services/apiAward'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, setQueryParams } from 'utils/utils'

export const VotingListContainer = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const { fetching: getAwardList, data: dataAwardList, isLoading } = useFetch(API_AWARD.AWARD_LIST)
    const { fetching: completeAward } = useFetch(API_AWARD.AWARD_COMPLETE)

    useEffect(() => {
        fetchAwardList(query)
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchAwardList = (item = { ...query }) => {
        getAwardList(item)
    }

    const onActionRow = ({ item, actionType }) => {
        switch (actionType) {
            case ACTION_TYPE.CREATE:
                navigate('/awards/voting/create')
                break
            case ACTION_TYPE.EDIT:
                navigate(`/awards/voting/create?id=${item.id}`)
                break
            case ACTION_TYPE.COMPLETE:
                onCompleteAward(item.id)
                break
            default:
                navigate(`/awards/voting/analytic?category=voter&id=${item.id}`)
                break
        }
    }

    const onCompleteAward = async (awardId) => {
        const isConfirm = await Alert({
            icon: 'warning',
            title: 'Confirmation',
            message: 'Apakah anda yakin ingin melakukan completed award?',
            buttonConfirmText: 'Ya',
            buttonCloseText: 'Tidak',
            backdrop: false,
        })

        if (isConfirm) {
            await completeAward({}, awardId)
            fetchAwardList(query)
        }
    }

    const props = {
        dataList: dataAwardList?.data,
        query,
        onChangeQuery,
        onActionRow,
        isLoading,
    }

    return <VotingList {...props} />
}
